import reactComponentLoader from 'scripts/react-component-loader'

import { MyOrders } from './'

reactComponentLoader(MyOrders, '[data-my-orders]')
